import { Button, ModalBody } from '@grupoboticario/flora-react';
import styled, { css, DefaultTheme } from 'styled-components';
import { TagType } from './ClaimStatus';

export const ModalBodyStyled = styled(ModalBody)`
  padding: 0 40px 40px 40px;
  background-color: ${({ theme }) => theme.colors.background};
  width: 58rem;

  header {
    > p {
      margin-left: 15px;
      font-weight: 500;
      font-size: 16px;
      line-height: 18px;
      color: ${({ theme }) => theme.colors.text};
    }
  }

  main {
    margin: 60px 0 0;
  }

  @media (max-width: 760px) {
    padding: inherit;
    margin-bottom: 20px;
  }
`;

export const ClaimInfo = styled.div`
  margin-top: 15px;
  padding: 15px;
  border-radius: 4px;

  background-color: ${({ theme }) => theme.colors.shape};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 550px) {
    flex-direction: column;
    align-items: inherit;
    justify-content: inherit;
  }
`;

export const ClaimDetails = styled.div`
  padding-right: 30px;
  min-width: 150px;

  & + & {
    padding-left: 10px;
    border-left: 0.5px solid ${({ theme }) => theme.colors.line};

    @media (max-width: 550px) {
      padding-left: 0;
      border-left: none;
      padding-top: 10px;
      border-top: 0.5px solid ${({ theme }) => theme.colors.line};
    }
  }

  .claim-text {
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;

    color: ${({ theme }) => theme.colors.main};
  }
  .claim-label {
    font-size: 13px;
  }
`;
export const Timeline = styled.div`
  position: relative;
  display: flex;
  padding: 0;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;

  .timeline-status:nth-child(5) {
    .claimStatus-line {
      display: none;
    }
  }
  .timeline-status:last-child {
    .claimStatus-line {
      display: none;
    }
  }
`;

export const TimelineHistory = styled.div`
  display: flex;
  padding: 0;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
  padding-left: 25px;
  padding-right: 25px;
  align-items: center;

  .claim-dot:last-of-type {
    display: none;
  }
`;

export const ClaimStatusSection = styled.div`
  display: flex;
  align-items: center;
`;

interface ClaimStatusWrapperProps {
  color?: TagType;
}

const getTagColor = (theme: DefaultTheme, color?: TagType) => {
  const colors = {
    normal: theme.colors.textLight,
    warning: theme.colors.warning,
    error: theme.colors.error,
    success: theme.colors.success,
    partial: theme.colors.partial,
    default: theme.colors.line,
  };
  return colors[color || 'default'];
};

export const ClaimStatusHistoryWrapper = styled.div<ClaimStatusWrapperProps>`
  min-width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  header {
    width: 100%;
    height: 22px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .tag {
      width: 95px;
      height: 22px;
      border-radius: 4px;

      background: ${({ theme, color }) => getTagColor(theme, color)};
      color: ${({ theme }) => theme.colors.shape};

      font-family: ${({ theme }) => theme.fonts.secondary};
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 0.08em;
      text-transform: uppercase;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (max-width: 760px) {
    min-width: 100px;
  }
`;

export const ClaimStatusWrapper = styled.div<ClaimStatusWrapperProps>`
  width: 100%;
  min-width: 150px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .claimStatus-line {
    position: absolute;
    top: 29%;

    width: 100%;
    height: 4px;
    margin-left: 100%;

    background-color: ${({ theme, color }) =>
      color === 'normal' ? theme.colors.main : theme.colors.line};
  }

  header {
    width: 100%;
    height: 22px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .tag {
      width: 95px;
      height: 22px;
      border-radius: 4px;

      background: ${({ theme, color }) => getTagColor(theme, color)};
      color: ${({ theme }) => theme.colors.shape};

      font-family: ${({ theme }) => theme.fonts.secondary};
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 0.08em;
      text-transform: uppercase;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (max-width: 760px) {
    min-width: 100px;
  }
`;
export const IconWrapper = styled.div<ClaimStatusWrapperProps>`
  height: 29px;
  display: flex;
  align-items: center;

  .icon {
    ${({ color }) =>
      color && color !== 'default'
        ? css`
            width: 29px;
            height: 29px;
          `
        : css`
            width: 17px;
            height: 17px;
          `};

    background-color: ${({ theme, color }) => getTagColor(theme, color)};

    border-radius: 25px;
    border: 3px solid ${({ theme }) => theme.colors.shape};
    z-index: 1;
    color: ${({ theme }) => theme.colors.shape};
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 63%;
      height: 63%;
    }
  }
`;
export const ClaimStatusContent = styled.div<ClaimStatusWrapperProps>`
  height: 106px;
  margin-top: 8px;

  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  text-align: center;
  color: ${({ theme }) => theme.colors.title};

  span.text {
    height: 30px;
    width: 90px;

    display: block;
    margin: 0 auto;
  }

  span.date {
    padding-top: 8px;
    margin-top: 8px;
    border-top: 1px solid ${({ theme }) => theme.colors.line};
    position: relative;
    display: flex;
    flex-direction: column;

    ${({ color, theme }) =>
      color === 'warning' &&
      css`
        border-top: 0;
        color: ${theme.colors.shape};
        padding: 7px;

        border-radius: 4px;
        background-color: ${theme.colors.warning};
      `};
  }
`;
export const ClaimStatusHistoryContent = styled.div<ClaimStatusWrapperProps>`
  height: 106px;
  margin-top: 8px;

  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  text-align: center;
  color: ${({ theme }) => theme.colors.title};

  span.text {
    height: 30px;
    width: 90px;

    display: block;
    margin: 0 auto;
  }

  span.date {
    padding-top: 8px;
    margin-top: 8px;
    border-top: 1px solid ${({ theme }) => theme.colors.line};
    position: relative;
    display: flex;
    flex-direction: column;
  }
`;

export const ActionButton = styled(Button)`
  width: 114px;
  height: 24px;
  font-size: 10px;
  margin-top: 15px;

  text-transform: uppercase;
`;

export const HistoryButton = styled(Button)`
  height: 24px;
  font-size: 10px;
  margin-top: 30px;

  text-transform: uppercase;

  svg {
    margin-left: 9px;
  }
`;

export const ArrowContainer = styled.div<{ type: 'left' | 'right' }>`
  width: 81px;
  height: 30px;
  top: 23%;
  position: absolute;
  z-index: 1;

  .swiper-button-disabled {
    display: none;
  }

  .timeline-arrow {
    position: absolute;
    padding: 6px;
    height: 30px;
    width: 30px;
    cursor: pointer;
    transition: opacity 0.2s;
    z-index: 100;
    background-color: ${({ theme }) => theme.colors.main};
    border-radius: 4px;
    svg {
      width: 100%;
      height: 100%;
      color: ${({ theme }) => theme.colors.shape};
    }
  }

  ${({ type }) =>
    type === 'left'
      ? css`
          left: -1%;
          background: linear-gradient(
            90deg,
            #f5f5f5 42.37%,
            rgba(245, 245, 245, 0) 100%
          );

          .timeline-arrow {
            left: 0;
          }
        `
      : css`
          right: -2%;
          background: linear-gradient(
            270deg,
            #f5f5f5 42.37%,
            rgba(245, 245, 245, 0) 100%
          );
          .timeline-arrow {
            right: 0;
          }
        `};

  @media (max-width: 760px) {
    background: inherit;
  }
`;
